import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { APIV2 } from "services/ApiServiceV2";

export const getHomeStories = createAsyncThunk(
  "home/getHomeStories",
  async (arg, thunkAPI) => {
    return await APIV2(
      `user/v1/user-profile/homepage/story/list?gender=${
        arg?.gender ? (arg?.gender == "men" ? "male" : "female") : "female"
      }&page=${arg?.page || 1}&size=${arg?.size || 10000}`,
      "GET",
      {},
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getStories = createAsyncThunk(
  "home/getHomeStories",
  async (arg, thunkAPI) => {
    return await APIV2(
      `user/v1/user-profile/homepage/story/list?gender=${
        arg?.gender ? (arg?.gender == "men" ? "male" : "female") : "female"
      }&page=${arg?.page || 1}&size=${arg?.size || 10000}`,
      "GET",
      {},
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getStoryDetails = createAsyncThunk(
  "home/getStoryDetails",
  async (arg, thunkAPI) => {
    return await APIV2(
      `user/v1/user-profile/homepage/story/details?storyId=${arg?.id}`,
      "GET",
      {},
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getHomePageData = createAsyncThunk(
  "home/getHomePageData",
  async (arg, thunkAPI) => {
    let url = "";
    url = `get/homePageData?userId=${
      thunkAPI.getState().AuthReducer.userId
    }&gender=${
      arg?.gender ? (arg?.gender == "men" ? "male" : "female") : "female"
    }`;

    return await APIV2(url, "GET")
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getHomeInstaPosts = createAsyncThunk(
  "home/getHomeInstaPosts",
  async (arg, thunkAPI) => {
    return await APIV2(`get/instagramPosts?gender=${ arg?.gender
      ? arg?.gender == "men"
        ? "male"
        : "female"
      : "female"}`, "GET")
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getClosetDigitisationData = createAsyncThunk(
  "home/getClosetDigitisationData",
  async (arg, thunkAPI) => {
    return await APIV2(
      `/user/v1/user-profile/homepage/closet/packages?userId=${
        thunkAPI.getState().AuthReducer.userId
      }`,
      "GET",
      arg,
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getFilteredProducts = createAsyncThunk(
  "home/getFilteredProducts",
  async (arg, thunkAPI) => {
    return await APIV2(
      "get/allProducts/v3",
      "POST",
      {
        ...arg?.data,
        ...(thunkAPI.getState().AuthReducer.userId
          ? { userId: thunkAPI.getState().AuthReducer.userId }
          : {}),
      },
      "NODE",
      arg?.abortSignal
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getProductDetailsApi = createAsyncThunk(
  "home/getProductDetailsApi",
  async (arg, thunkAPI) => {
    let url = "";
    if (arg?.id) {
      url = `get/productDetails?productId=${arg?.productId}&personalStylistId=${
        thunkAPI.getState().AuthReducer.userId
      }&userId=${arg?.id}`;
    } else {
      url = `get/productDetails?productId=${arg?.productId}&userId=${
        thunkAPI.getState().AuthReducer.userId
      }`;
    }

    return await APIV2(url, "GET")
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getVideos = createAsyncThunk(
  "home/getVideos",
  async (arg, thunkAPI) => {
    return await APIV2(
      `user/v1/video/v3/api/video-list?userId=${
        thunkAPI.getState().AuthReducer.userId
      }&page=${arg?.page}&size=${arg?.size}&gender=${ arg?.gender
        ? arg?.gender == "men"
          ? "male"
          : "female"
        : "female"}`,
      "GET",
      arg,
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getHomeCategories = createAsyncThunk(
  "home/getHomeCategories",
  async (arg, thunkAPI) => {
    return await APIV2(
      `get/homePageCategories?gender=${ arg?.gender
        ? arg?.gender == "men"
          ? "male"
          : "female"
        : "female"}`,
      "GET",
      arg,
      "NODE"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getHomeSearchBrands = createAsyncThunk(
  "home/getHomeSearchBrands",
  async (arg, thunkAPI) => {
    return await APIV2(
      `get/homePageBrands?gender=${ arg?.gender
        ? arg?.gender == "men"
          ? "male"
          : "female"
        : "female"}`,
      "GET",
      arg,
      "NODE"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

let initialState = {
  homeStories: [],
  homeScrollToTop: 0,
  closetDigitisationData: [],
  homeStoriesLoading: false,
  homeData: [],
  homeDataLoading: false,
  homeCategories: [],
  homeCategoriesLoading: false,
  instaPosts: [],
  homeVideos: [],
  instaPostsLoading: false,
  homeVideosLoading: false,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setHomeScrollToTop: (state, action) => {
      state.homeScrollToTop = action.payload;
    },
    resetHomeSlice: (state) => {
      state.homeStories = initialState.homeStories;
      state.homeScrollToTop = initialState.homeScrollToTop;
      state.closetDigitisationData = initialState.closetDigitisationData;
      state.homeStoriesLoading = initialState.homeStoriesLoading;
      state.homeData = initialState.homeData;
      state.homeDataLoading = initialState.homeDataLoading;
      state.homeCategories = initialState.homeCategories;
      state.homeCategoriesLoading = initialState.homeCategoriesLoading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHomeStories.pending, (state, action) => {
        state.homeStoriesLoading = true;
      })
      .addCase(getHomeStories.fulfilled, (state, action) => {
        if ([200].includes(action?.payload?.status)) {
          state.homeStories = action.payload?.data?.stories;
        }
        state.homeStoriesLoading = false;
      })
      .addCase(getHomeStories.rejected, (state, action) => {
        console.error("getHomeStories api error", action?.payload);
        state.homeStoriesLoading = false;
      })
      .addCase(getHomePageData.pending, (state, action) => {
        state.homeDataLoading = true;
      })
      .addCase(getHomePageData.fulfilled, (state, action) => {
        if (
          [200].includes(action?.payload?.status) &&
          Array.isArray(action.payload?.data?.data)
        ) {
          state.homeData = action.payload?.data?.data;
        }
        state.homeDataLoading = false;
      })
      .addCase(getHomePageData.rejected, (state, action) => {
        console.error("getHomePageData api error", action?.payload);
        state.homeDataLoading = false;
      })
      .addCase(getClosetDigitisationData.pending, (state, action) => {})
      .addCase(getClosetDigitisationData.fulfilled, (state, action) => {
        if ([200].includes(action?.payload?.status)) {
          state.closetDigitisationData = action.payload?.data;
        }
      })
      .addCase(getClosetDigitisationData.rejected, (state, action) => {
        console.error("getHomeStories api error", action?.payload);
      })
      .addCase(getHomeCategories.pending, (state, action) => {
        state.homeCategoriesLoading = true;
      })
      .addCase(getHomeCategories.fulfilled, (state, action) => {
        if (
          [200].includes(action?.payload?.status) &&
          action.payload?.data?.data &&
          Array.isArray(action.payload?.data?.data)
        ) {
          state.homeCategories = action.payload?.data?.data;
        }
        state.homeCategoriesLoading = false;
      })
      .addCase(getHomeCategories.rejected, (state, action) => {
        state.homeCategoriesLoading = false;
        console.log("homeCategoriesLoading api error", action?.payload);
      })
      .addCase(getHomeInstaPosts.pending, (state, action) => {
        state.instaPostsLoading = true;
      })
      .addCase(getHomeInstaPosts.fulfilled, (state, action) => {
        if (
          [200].includes(action?.payload?.status) &&
          action.payload?.data?.data &&
          Array.isArray(action.payload?.data?.data)
        ) {
          state.instaPosts = action.payload?.data?.data;
        }
        state.instaPostsLoading = false;
      })
      .addCase(getHomeInstaPosts.rejected, (state, action) => {
        state.instaPostsLoading = false;
        console.log("getHomeInstaPosts api error", action?.payload);
      })

      .addCase(getVideos.pending, (state, action) => {
        state.homeVideosLoading = true;
      })
      .addCase(getVideos.fulfilled, (state, action) => {
        if (
          [200].includes(action?.payload?.status) &&
          action.payload?.data?.data &&
          Array.isArray(action.payload?.data?.data)
        ) {
          state.homeVideos = action.payload?.data?.data;
        }
        state.homeVideosLoading = false;
      })
      .addCase(getVideos.rejected, (state, action) => {
        state.homeVideosLoading = false;
        console.log("getVideos api error", action?.payload);
      });
  },
});

export const { setHomeScrollToTop, resetHomeSlice } = homeSlice.actions;

export default homeSlice.reducer;
